import { render } from "./TitleDesc.vue?vue&type=template&id=e7d8e13c&bindings={\"title\":\"props\"}"
import script from "./TitleDesc.vue?vue&type=script&lang=js"
export * from "./TitleDesc.vue?vue&type=script&lang=js"

import "./TitleDesc.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script